var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',[_c('span',[_vm._v("关于我们")]),_c('span',[_vm._v(" | ")]),_c('span',[_c('a',{staticStyle:{"color":"#7b7b7b"},attrs:{"href":"https://www.hi-wooya.com/","target":"_blank"}},[_vm._v("无涯官网")])])]),_c('div',[_c('span',[_vm._v("版权所有©四川无涯智能科技有限公司( 蜀ICP备20020584号-1)")])])])
}]

export { render, staticRenderFns }